import React, {useEffect, useState} from "react"

import {Badge, Button, Card, CardBody, Col, Container, Row} from "reactstrap"
import {Link} from "react-router-dom"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTitle from "../../components/MetaTitle"
import ProgressView from "../../components/ProgressView"
import useRefundDetail from "../../hooks/useRefundDetail"

const STATUS_COLORS = {
    requested: "warning",
    pending: "info",
    confirmed: "success",
    failed: "danger",
    cancelled: "secondary",
}

const formatAmount = (minor, currency) => {
    if (minor == null) return "—"
    return `${currency || ""} ${(minor / 100).toFixed(2)}`.trim()
}

const formatDate = (iso) => (iso ? new Date(iso).toLocaleString() : "—")

const RefundDetail = ({match, ...rest}) => {
    const {id} = match.params
    const {refund, isLoading, isCancelling, loadRefund, cancelRefund} = useRefundDetail(id)
    const [confirmOpen, setConfirmOpen] = useState(false)

    useEffect(() => {
        loadRefund()
    }, [id])

    const canCancel = refund && (refund.status === "requested" || refund.status === "pending")

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTitle title="Refund Detail"/>
                <Container fluid={true}>
                    <Breadcrumbs title="Billing" breadcrumbItem="Refund Detail" {...rest}/>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>

                                    {isLoading &&
                                    <div className="p-2 text-center">
                                        <ProgressView/>
                                    </div>
                                    }

                                    {!isLoading && !refund &&
                                    <p className="text-muted">Refund not found.</p>
                                    }

                                    {!isLoading && refund &&
                                    <>
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <div>
                                                <h5 className="mb-1">Refund #{refund.id?.slice(0, 8)}</h5>
                                                <Badge color={STATUS_COLORS[refund.status] || "secondary"}>
                                                    {refund.status}
                                                </Badge>
                                            </div>
                                            <div>
                                                <Link to="/refunds" className="btn btn-sm btn-light me-2">
                                                    Back
                                                </Link>
                                                {canCancel && (
                                                    confirmOpen ? (
                                                        <>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                disabled={isCancelling}
                                                                onClick={() => cancelRefund(() => setConfirmOpen(false))}
                                                            >
                                                                {isCancelling ? "Cancelling…" : "Confirm Cancel"}
                                                            </Button>{" "}
                                                            <Button
                                                                color="secondary"
                                                                size="sm"
                                                                onClick={() => setConfirmOpen(false)}
                                                            >
                                                                Keep
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <Button
                                                            color="warning"
                                                            size="sm"
                                                            onClick={() => setConfirmOpen(true)}
                                                        >
                                                            Cancel Refund
                                                        </Button>
                                                    )
                                                )}
                                            </div>
                                        </div>

                                        <Row>
                                            <Col md="6">
                                                <p>
                                                    <strong>Business:</strong>{" "}
                                                    <Link to={"/business/" + refund.business_id}>
                                                        {refund.business_name || refund.business_id}
                                                    </Link>
                                                </p>
                                                <p><strong>Payment ID:</strong> {refund.payment_id || "—"}</p>
                                                <p><strong>Amount:</strong> {formatAmount(refund.amount_minor, refund.currency)}</p>
                                                <p><strong>Reason:</strong> {refund.reason || "—"}</p>
                                            </Col>
                                            <Col md="6">
                                                <p><strong>Created:</strong> {formatDate(refund.created_at)}</p>
                                                <p><strong>Confirmed:</strong> {formatDate(refund.confirmed_at)}</p>
                                                <p><strong>Gateway Ref:</strong> {refund.gateway_reference || "—"}</p>
                                                <p><strong>Initiated By:</strong> {refund.initiated_by_user_id || "—"}</p>
                                            </Col>
                                        </Row>
                                    </>
                                    }

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default RefundDetail
